export const CompanyDistance = ({distance}) => {
  return <div className="distance">{distance} KM</div>;
};
